export function getInitialState() {
  if (typeof INITIAL_JSON !== 'undefined') {
    return INITIAL_JSON; // eslint-disable-line no-undef
  }
  return null;
}

export function isServerSideRenderer() {
  return !!window.ssr;
}
